import { render, staticRenderFns } from "./examinationOutlineAdd.vue?vue&type=template&id=b810dd66&scoped=true"
import script from "./examinationOutlineAdd.vue?vue&type=script&lang=js"
export * from "./examinationOutlineAdd.vue?vue&type=script&lang=js"
import style0 from "./examinationOutlineAdd.vue?vue&type=style&index=0&id=b810dd66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b810dd66",
  null
  
)

export default component.exports